import PageTerraformWorkspacesList from 'hcp/components/page/terraform/workspaces/list';

<template>
  <PageTerraformWorkspacesList
    @workspaces={{@model.resources}}
    @pagination={{@model.pagination}}
    @leafNameFilter={{@model.leafNameFilter}}
    @currentPageSize={{@model.currentPageSize}}
    @onPageSizeChange={{@controller.onPageSizeChange}}
    @orgId={{@model.organizationId}}
    @projectId={{@model.projectId}}
  />
</template>
